import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../../../API";
import { isAutheticated } from "../../auth/authhelper";
import { Link, useParams } from "react-router-dom";
import Footer from "../Footer";
export default function ViewSt() {
  const { token } = isAutheticated();
  const { id } = useParams();
  const [staff, setStaff] = useState({
    email: "",
    name: "",
    mobile: "",
    status: "",
    featuredImage: "",
    permissions: [],
  });

  useEffect(() => {
    axios
      .get(`${API}/api/staff/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const { email, name, mobile, status, featuredImage, permissions } =
          response.data.data;
        setStaff({
          email,
          name,
          mobile,
          status,
          featuredImage,
          permissions,
        });
      });
  }, [id, token]);

  return (
    <div className='main-content'>
      <div className='page-content'>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col-12'>
              <div className='page-title-box d-flex align-items-center justify-content-between'>
                <h4 className='mb-0'>Staff - View</h4>
                <div className='page-title-right'>
                  <ol className='breadcrumb m-0'>
                    <li className='breadcrumb-item'>
                      <Link to='/'>SoComOTT</Link>
                    </li>
                    <li className='breadcrumb-item'>Staff</li>
                    <li className='breadcrumb-item'>View</li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-lg-12'>
              <div className='card col-lg-8 mx-auto'>
                <div className='card-body'>
                  <div className='row text-end'>
                    <Link to='/staff'>
                      <button className='btn btn-secondary'>Back</button>
                    </Link>
                  </div>
                  <div className='row'>
                    <div className='col-lg-7'>
                      <h1 className='text-left head-small'>
                        Name: {staff.name}
                      </h1>
                      <div className='mt-15 label-100'>
                        Email: {staff.email}
                      </div>
                      <div className='label-100'>Mobile no: {staff.mobile}</div>
                      <div className='label-100'>
                        Status:{" "}
                        <div
                          className={
                            staff.status
                              ? "badge text-bg-success"
                              : "badge text-bg-danger"
                          }>
                          {staff.status ? "Active" : "Inactive"}
                        </div>
                      </div>
                      <div className='mt-20 label-100'>Permissions :</div>
                      {staff?.permissions.includes("Subscribers") && (
                        <div className='ml-2 label-100'>Subscribers</div>
                      )}
                      {staff?.permissions.some((x) =>
                        ["Videos", "Advertisemets", "Banners"].includes(x)
                      ) && (
                          <div className='ml-2'>
                            <div
                              className='label-100'
                              style={{ textDecoration: "underline" }}>
                              Content Management :
                            </div>
                            {staff?.permissions.includes("Videos") && (
                              <div className='ml-4 label-100'>Videos</div>
                            )}
                            {staff?.permissions.includes("Advertisemets") && (
                              <div className='ml-4 label-100'>Advertisemets</div>
                            )}
                            {staff?.permissions.includes("Banners") && (
                              <div className='ml-4 label-100'>Banners</div>
                            )}
                          </div>
                        )}
                      {staff?.permissions.some((x) =>
                        [
                          "Products",
                          "Featured Products",
                          "Category",
                          "Coupons",
                          "Shipping",
                        ].includes(x)
                      ) && (
                          <div className='ml-2'>
                            <div
                              className='label-100'
                              style={{ textDecoration: "underline" }}>
                              Commerce :
                            </div>
                            {staff?.permissions.includes("Products") && (
                              <div className='ml-4 label-100'>Products</div>
                            )}
                            {staff?.permissions.includes("Featured Products") && (
                              <div className='ml-4 label-100'>
                                Featured Products
                              </div>
                            )}
                            {staff?.permissions.includes("Category") && (
                              <div className='ml-4 label-100'>Category</div>
                            )}
                            {staff?.permissions.includes("Coupons") && (
                              <div className='ml-4 label-100'>Coupons</div>
                            )}
                            {staff?.permissions.includes("Shipping") && (
                              <div className='ml-4 label-100'>Shipping</div>
                            )}
                          </div>
                        )}
                      {staff?.permissions.includes("Earnings") && (
                        <div className='ml-2 label-100'>Earnings</div>
                      )}
                      {staff?.permissions.includes("Payment Setting") && (
                        <div className='ml-2 label-100'>Payment Setting</div>
                      )}
                      {staff?.permissions.includes("Configuration") && (
                        <div className='ml-2 label-100'>Configuration</div>
                      )}
                    </div>
                    <div className='col-lg-5 text-end'>
                      <img
                        src={staff.featuredImage}
                        width={200}
                        height={200}
                        alt={staff.name}
                        className='img-thumbnail'
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
